import { getSintegradaServerApi } from "@/services/api";
import { Pagination } from "@/@types/sintegrada/sintegradaServerApi/Pagination";

type Props = {
    ibgeCode: string;
    page?: number;
    search?: string;
};

export type TransferUnit = {
    id: number;
    name: string;
    city: string;
    type: string;
    cnes: string;
    updated_at: string;
    created_at: string;
};

type PaginatedTransferUnit = Pagination<TransferUnit>;

export async function getTransferUnits({ ibgeCode, page, search }: Props) {
    const { data } = await getSintegradaServerApi().get<PaginatedTransferUnit>("/transfer-units", {
        ibgeCode,
        page,
        search,
    });

    return data || {} as PaginatedTransferUnit;
}
